// extracted by mini-css-extract-plugin
module.exports = {"verticalDots":"VerticalDots_verticalDots__rb8WG"};